import { DefaultButton, PrimaryButton, TooltipHost } from '@fluentui/react';
import { Flex, FlexItem, Label } from '@fluentui/react-northstar';
import * as microsoftTeams from "@microsoft/teams-js";
import { useBoolean, useId } from '@uifabric/react-hooks';
import { IconButton, IIconProps } from 'office-ui-fabric-react';
import { Dialog, DialogFooter, DialogType, IDialogContentProps, IDialogStyles } from 'office-ui-fabric-react/lib/Dialog';
import { IStackTokens, Stack } from 'office-ui-fabric-react/lib/Stack';
import * as React from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import HubShareDialog from '../../components/HubShare/dialog';
import MeetingFileItem from '../../components/MeetingFileItem';
import { HubFile } from '../../model';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import { getMeetingsContents, inMeetingSearch, removeContent, updateMessage, updateRemoveFile } from '../../store/Meeting/actions';
import styles from './index.module.scss';
//import hubService from '../../api/services/hub';
//import envConfig from '../../config';

const InMeeting = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const stackTokens: Partial<IStackTokens> = { childrenGap: 20 };
    const addIcon: IIconProps = { iconName: 'Add' };
    const presentIcon: IIconProps = { iconName: 'Presentation12' };
    const shareIcon: IIconProps = { iconName: 'Share' };
    const deleteIcon: IIconProps = { iconName: 'Delete' };
    const {
        teamEvent,
        currentMeeting,
        selectedFilesForRemove
    } = useTypedSelector((state: ApplicationState) => state.meeting);

    const {
        filesAddedMessage,
        currentBookmarkSelection
    } = useTypedSelector((state: ApplicationState) => state.meeting);

    React.useEffect(() => {
        microsoftTeams.getContext(({ chatId }) => {
            if (chatId) {
                dispatch(getMeetingsContents(chatId));
            }
        });
    }, []);

    React.useEffect(() => {

    }, [currentMeeting]);

    React.useEffect(() => {
        const timeId = setTimeout(() => {
            setShow(false)
        }, 5000)
        return () => {
            clearTimeout(timeId)
        }
    }, [filesAddedMessage]);

    const [show, setShow] = React.useState(true)

    const [selectedFileIds, updateSelectedFileIds] = React.useState([] as {
        file: HubFile;
        fileId: number;
        shareUrl: string;
        checked: boolean;
    }[]);

    const horizontalGapStackTokens: IStackTokens = {
        childrenGap: 5,
    };

    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
    const [hideDelete, { toggle: toggleHideDelete }] = useBoolean(false);
    const labelId: string = useId('dialogLabel');
    const subTextId: string = useId('subTextLabel');

    const onRemoveFile = () => {
        selectedFileIds.forEach((id) => { dispatch(updateRemoveFile(id.fileId as number, 'add')); })
        currentBookmarkSelection.forEach((id) => { dispatch(updateRemoveFile(id as number, 'add')); });
        dispatch(removeContent(selectedFilesForRemove, currentMeeting.id));
        dispatch(inMeetingSearch("", []));
        updateSelectedFileIds([]);
        toggleHideDialog();
    }

    const onItemCheckedChanged = (file: HubFile, fileId: number, shareUrl: string, checked: boolean) => {
        if (!checked) {
            const tmpIds = selectedFileIds.filter(c => c.fileId !== fileId);
            updateSelectedFileIds(tmpIds);
        }
        else {
            const tmpIds = [...selectedFileIds, {
                file,
                fileId,
                shareUrl,
                checked
            }];
            updateSelectedFileIds(tmpIds);
        }
    }

    const presentContent = () => {
        if (selectedFileIds.length > 0) {
            selectedFileIds.map((file) => { file.fileId && window.open(`https://app.bigtincan.com/file/${file.fileId}`); });
        }
        else {
            currentMeeting && currentMeeting.meetingContents && currentMeeting.meetingContents.map((file) => {
                file.fileId && window.open(`https://app.bigtincan.com/file/${file.fileId}`);
            });
        }
    }

    //Tabbed view is disabled for now
    //const presentContent = () => {
    //    if (selectedFileIds.length > 0) {
    //        localStorage.setItem("PresentContentInvoke", "Y");
    //        var data = selectedFileIds;
    //        localStorage.setItem("PresentContentData", JSON.stringify(data));
    //        microsoftTeams.executeDeepLink("https://teams.microsoft.com/l/entity/22bb10e2-6cc9-491f-98f0-67b21e7ede9c/preMeetingTab");
    //    }
    //}

    const onCancelClick = () => {
        if (hideDelete) {
            toggleHideDelete();
        }
        if (!hideDialog) {
            toggleHideDialog();
        }
    }

    const modalPropsStyles = {
        main: { color: '#FFFFFF' }, header: { color: '#FFFFFF' }
    };

    const modalProps = React.useMemo(
        () => ({
            titleAriaId: labelId,
            subtitleAriaId: subTextId,
            isBlocking: true,
            isModeless: false,
            isDarkOverlay: true,
            styles: modalPropsStyles,
            className: '.ms-Dialog-title'
        }),
        [labelId, subTextId],
    );

    const dialogContentProps: IDialogContentProps = {
        showCloseButton: false,
        type: DialogType.normal,
        title: 'Remove File',
        styles: {
            subText: { color: '#F2F2F2' }
        },
        titleProps: {
            style: { color: 'white' }
        },
        subText: 'This will remove the selected file(s) from your presentation.',
    };

    const dialogStyles: IDialogStyles = {
        root: [{

        }],
        main: [{
            selectors: {
                ['@media (min-width: 260px)']: {
                    maxWidth: '260px',
                    minWidth: '260px',
                    background: '#201F1F'
                }
            }
        }]
    };


    const onSuccess = () => {
        updateSelectedFileIds([]);
        dispatch(updateMessage('Content successfully shared'));
    };

    React.useEffect(() => {
        if (teamEvent) {
            const attendees = teamEvent.attendees.map(c => {
                return {
                    email: c.emailAddress.address,
                    name: c.emailAddress.name,
                    status: c.status.response,
                }
            });
            setAttendies(attendees);
        }
    }, [teamEvent]);

    const [showShareDialog, { toggle: toggleShareDialog, setTrue: hideDialogShare }] = useBoolean(false);
    const [attendies, setAttendies] = React.useState([] as {
        email: string,
        name: string,
        status: string
    }[]);

    const [currentFiles, setCurrentFiles] = React.useState([] as HubFile[]);

    const updateShareItems = () => {
        let tempFiles = ([] as HubFile[]);
        for (var i = 0; i < selectedFileIds.length; i++) {
            if (selectedFileIds[i].file.shareStatus != 'blocked')
                tempFiles.push(selectedFileIds[i].file);
        }
        setCurrentFiles(tempFiles);
    };

    return (
        <Stack className={styles.root} tokens={horizontalGapStackTokens}>
            {!showShareDialog && <Flex className={styles.header} gap="gap.small">
                <FlexItem>
                    <div className={styles.presentation}>My Presentation</div>
                </FlexItem>
            </Flex>}
            {!showShareDialog && <Stack tokens={stackTokens} className={styles.list}>
                {currentMeeting && currentMeeting.meetingContents && currentMeeting.meetingContents.map((item) => {
                    return <Stack.Item key={item.fileId}>
                        <MeetingFileItem item={item} onItemClick={() => { }} onCheckedItemChange={onItemCheckedChanged} key={item.fileId} id={item.fileId} />
                    </Stack.Item>
                })}
            </Stack>}
            {!showShareDialog && filesAddedMessage && show &&
                <Stack className={styles.messageBar}>
                    <Label className={styles.lblCheck}>&#10004;</Label>
                    <Label className={styles.lblMessage}>{filesAddedMessage}</Label>
                    <Label className={styles.lblUndo} onClick={onRemoveFile}>Undo</Label>
                </Stack>}
            <div className={styles.divider} />
            {!showShareDialog && <Stack className={styles.btnContent}>
                <TooltipHost content={'Add Files'}><IconButton className={styles.btnAddContent} iconProps={addIcon} onClick={() => { dispatch(inMeetingSearch("", [])); history.push("/inmeetingsearch"); }} /></TooltipHost>
                <TooltipHost content={'Present Content'}><IconButton className={styles.btnPresentContent} iconProps={presentIcon} onClick={() => { presentContent() }}/></TooltipHost>
                <TooltipHost content={'Share Files'}><IconButton className={styles.btnShareContent} iconProps={shareIcon} onClick={() => { updateShareItems(); toggleShareDialog(); }} disabled={selectedFileIds.length === 0} /></TooltipHost>
                <TooltipHost content={'Delete Files'}><IconButton className={styles.btnRemoveContent} iconProps={deleteIcon} onClick={() => { toggleHideDialog() }} disabled={selectedFileIds.length === 0} /></TooltipHost>
            </Stack>}
            <Dialog hidden={hideDialog}
                onDismiss={toggleHideDialog}
                dialogContentProps={dialogContentProps}
                modalProps={modalProps}
                styles={dialogStyles}>
                <DialogFooter>
                    <DefaultButton style={{ color: ' #FFFFFF', background: 'rgba(0, 0, 0, 0.1)', padding: '10px 12px' }} onClick={onCancelClick} text="Cancel" />
                    <PrimaryButton style={{ color: ' #FFFFFF', background: '#C4314B', padding: '10px 12px' }} onClick={onRemoveFile} text="Remove" />
                </DialogFooter>
            </Dialog>
            {showShareDialog && <HubShareDialog inMeeting={'render'} subject={teamEvent ? teamEvent.subject : ''} onSuccess={onSuccess} attendee={attendies} files={currentFiles} onDismiss={() => { updateSelectedFileIds([]); toggleShareDialog(); }} isOpen={showShareDialog} isMobile={true} />}
        </Stack>
    )
};

export default connect()(InMeeting);
